import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import 'bootstrap/dist/css/bootstrap.min.css';

const AddStudentCourse = () => {
  const [levels, setLevels] = useState([]);
  const [selectedLevel, setSelectedLevel] = useState('');
  const [courses, setCourses] = useState({});
  const [studentEnrolledCourses, setStudentEnrolledCourses] = useState([]);
  const [filterType, setFilterType] = useState('');
  const [filterValue, setFilterValue] = useState('');
  const [showFilterOptions, setShowFilterOptions] = useState(false);
  const [toast, setToast] = useState({ message: "", show: false });

  const token = localStorage.getItem('token');
  const navigate = useNavigate();

  const showToast = (message) => {
    setToast({ message, show: true });
    setTimeout(() => setToast({ message: "", show: false }), 3000);
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const teacherRes = await fetch('http://193.123.94.90/teacher-listing', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({}),
        });

        const studentRes = await fetch('http://193.123.94.90/student-profile', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify({}),
        });

        if (teacherRes.ok && studentRes.ok) {
          const teacherData = await teacherRes.json();
          const studentData = await studentRes.json();

          setLevels(Object.keys(teacherData));
          setCourses(teacherData);

          const transformed = (studentData.coursename || []).map((course, index) => ({
            title: course,
            teacher: studentData.teachers?.[index],
            level: studentData.courselevel?.[index],
          }));
          setStudentEnrolledCourses(transformed);
        } else {
          showToast("❌ Failed to fetch data.");
        }
      } catch (error) {
        console.error('Error fetching data:', error);
        showToast("🚫 Error loading course or student data.");
      }
    };

    fetchData();
  }, [token]);

  const isCourseEnrolled = (courseName, teacherName, level) => {
    return studentEnrolledCourses.some(
      (course) => course.title === courseName && course.teacher === teacherName && course.level === level
    );
  };

  const handleEnroll = async (level, course, teacherName, teacherId) => {
    try {
      const response = await fetch('http://193.123.94.90/enroll-course', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: `Bearer ${token}`,
        },
        body: JSON.stringify({
          coursename: course[1],
          level,
          tutor_id: teacherId,
        }),
      });

      if (response.ok) {
        showToast(`✅ Enrolled in ${course[1]} with ${teacherName}`);
        setStudentEnrolledCourses((prev) => [...prev, { title: course[1], teacher: teacherName, level }]);
      } else {
        showToast("⚠️ Failed to enroll.");
      }
    } catch (error) {
      console.error('Error during enrollment:', error);
      showToast("🚫 Enrollment error. Try again.");
    }
  };

  const applyFilter = (courseArray) => {
    if (!filterType || !filterValue) return courseArray;

    return courseArray.filter((course) => {
      switch (filterType) {
        case 'rate-lt':
          return Number(course[3]) < Number(filterValue);
        case 'rate-gt':
          return Number(course[3]) > Number(filterValue);
        case 'teacher':
          return course[0].toLowerCase().includes(filterValue.toLowerCase());
        case 'course':
          return course[1].toLowerCase().includes(filterValue.toLowerCase());
        case 'rating':
          return Number(course[2]) >= Number(filterValue);
        default:
          return true;
      }
    });
  };

  return (
    <div className="container-fluid py-5 position-relative" style={{ backgroundColor: '#ffeae9', cursor: 'url("/pencil-cursor.png"), auto' }}>
      <div style={{
        backgroundImage: 'url("/background.jpg")',
        backgroundSize: 'contain',
        backgroundRepeat: 'repeat',
        backgroundPosition: 'center',
        opacity: 0.06,
        position: 'absolute',
        inset: 0,
        zIndex: 0
      }}></div>

      {toast.show && (
        <div className="position-fixed top-0 start-50 translate-middle-x mt-3 px-4 py-2 rounded bg-dark text-white shadow" style={{ zIndex: 1050 }}>
          {toast.message}
        </div>
      )}

      <div className="container position-relative" style={{ zIndex: 1 }}>
        <div className="position-absolute" style={{ top: '20px', left: '20px', zIndex: 2 }}>
          <button
            className="btn btn-sm d-flex align-items-center gap-2 px-3 py-1"
            onClick={() => navigate('/profile/student')}
            style={{ backgroundColor: '#ffffffcc', borderRadius: '8px', fontSize: '14px' }}
          >
            <img src="/arrow_back.png" alt="Go Back" style={{ width: '16px' }} />
            Back
          </button>
        </div>

        <div className="text-center mb-5">
          <h1 className="display-4">Student Course Gallery</h1>
        </div>

        <div className="mb-4">
          <label className="form-label me-2">Select Level:</label>
          <select className="form-select d-inline w-auto" value={selectedLevel} onChange={(e) => setSelectedLevel(e.target.value)}>
            <option value="">All Levels</option>
            {levels.map((level, index) => (
              <option key={index} value={level}>{level}</option>
            ))}
          </select>
        </div>

        <button className="btn btn-outline-secondary mb-3" onClick={() => setShowFilterOptions(!showFilterOptions)}>
          {showFilterOptions ? 'Hide Filter' : 'Add a Filter'}
        </button>

        {showFilterOptions && (
          <div className="card p-3 mb-4">
            <div className="mb-3">
              <label className="form-label">Filter By:</label>
              <select className="form-select" value={filterType} onChange={(e) => setFilterType(e.target.value)}>
                <option value="">-- Select Filter Type --</option>
                <option value="rate-lt">Rate &lt;</option>
                <option value="rate-gt">Rate &gt;</option>
                <option value="teacher">Teacher Name</option>
                <option value="course">Course Name</option>
                <option value="rating">Rating ≥</option>
              </select>
            </div>
            {filterType && (
              <div className="d-flex align-items-center">
                <input
                  type="text"
                  className="form-control me-2"
                  placeholder="Enter value"
                  value={filterValue}
                  onChange={(e) => setFilterValue(e.target.value)}
                />
                <button className="btn btn-primary" style={{ backgroundColor: '#f5b5b5', color: 'white' }} onClick={() => setShowFilterOptions(false)}>Apply</button>
              </div>
            )}
          </div>
        )}

        {Object.entries(courses).map(([level, courseArray]) => {
          if (selectedLevel && selectedLevel !== level) return null;
          const filteredCourses = applyFilter(courseArray);

          return (
            <div key={level} className="mb-5">
              <h4 className="mb-3">Courses Available for {level}</h4>
              <div className="row g-4">
                {filteredCourses.map((course, index) => {
                  const enrolled = isCourseEnrolled(course[1], course[0], level);
                  return (
                    <div key={index} className="col-md-6 col-lg-4">
                      <div className="card shadow-sm" style={{ minHeight: '320px' }}>
                        <div className="card-body d-flex flex-column justify-content-between">
                          <div>
                            <h5 className="card-title">{course[1]}</h5>
                            <p className="card-text"><strong>Teacher:</strong> {course[0]}</p>
                            <p className="card-text"><strong>Rating:</strong> {course[2]}</p>
                            <p className="card-text"><strong>Rate:</strong> {course[3]}</p>
                            <p className="card-text"><strong>Enrolled Students:</strong> {course[4]}</p>
                          </div>
                          <button
                            className={`btn ${enrolled ? 'btn-secondary' : 'btn-primary'} btn-sm w-100 mt-3`}
                            style={!enrolled ? { backgroundColor: '#0d6efd', borderColor: '#0d6efd' } : { backgroundColor: '#adb5bd', borderColor: '#adb5bd' }}
                            onClick={() => handleEnroll(level, course, course[0], course[5])}
                            disabled={enrolled}
                          >
                            {enrolled ? 'Enrolled' : 'Enroll'}
                          </button>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AddStudentCourse;
